export const payrollProtectionKeys = {
  // Generic fields
  NO_OF_PRACTITIONERS: 'noofPractitioners',
  // Practice Type and related fields
  PRACTICE_TYPE: 'typeOfPractice',
  IDENTIFIER_TYPE: 'identifierType',
  NPI_NUMBER: 'npiNumber',
  VETERINARIAN_ID: 'veterinarianNumber',

  // Policy Holder Details
  FIRST_NAME: 'firstName',
  MIDDLE_NAME: 'middleName',
  LAST_NAME: 'lastName',
  SUFFIX: 'suffix',
  DATE_OF_BIRTH: 'dateOfBirth',
  SMOKER: 'smokerNonSmoker',
  VERTERINARIAN_STATE: 'veterinarianState',

  // Address fields
  ADDRESS_LINE1: 'addressLine1',
  ADDRESS_LINE2: 'addressLine2',
  CITY: 'city',
  STATE: 'state',
  ZIP: 'zip',
  COUNTRY: 'country',
  LOCATIONS: 'locations',
  IS_MANUAL_ADDRESS: 'isManualAddress',

  // Agency fields
  AGENCY_DETAILS: 'agencydetails',
  AGENT_DETAILS: 'agentdetails',

  //Policy Holder
  PolicyEffectiveDate: 'policyEffectiveDate',
  PolicyExpirationDate: 'policyExpirationDate',
  AddOfficeContacts: 'AddOfficeContacts',
  AddAdditionalPractitioner: 'AddAdditionalPractitioner',
  AddPractitionerLocations: 'additional-locations',

  //Additional Practitioner
  PractitionerIdentifierType: 'PractitionerIdentifierType',
  PractitionerLicenseNumber: 'PractitionerLicenseNumber',
  PractitionerNpiNumber: 'PractitionerNpiNumber',
  PractitionerVeterinarianNumber: 'PractitionerVeterinarianNumber',
  PractitionerDateOfBirth: 'PractitionerDateOfBirth',

  //Coverage Plan Keys
  PayrollProtectionPlusLimit: 'PayrollProtectionPlusLimit',
  LeasedMedicalEquipmentLimit: 'LeasedMedicalEquipmentLimit',
  MedicalPracticeLoanLimit: 'MedicalPracticeLoanLimit',
  LeasedMedicalEquipmentToggle: 'LeasedMedicalEquipmentToggle',
  MedicalPracticeLoanToggle: 'MedicalPracticeLoanToggle',
};

export const practiceTypes = {
  PHYSICIAN: 'Physician',
  DENTIST: 'Dentist',
  CHIROPRACTOR: 'Chiropractor',
  VETERINARIAN: 'Veterinarian',
};

export const routeKeys = {
  Root: '/',
  InternalServerError: '/500',
  NotFound: '/404',
  // QuoteIndication: '/Quote/Indication',
  LobSelection: 'dashboard/line-lob-selection',
  QuoteIndication: '/Quote/QuoteIndication',
  ApplicationPolicyHolder: '/Commercial/PayrollProtection/Application/PolicyHolder',
  ApplicationRiskQualifiers: '/Application/RiskQualifiers',
  ApplicationRiskQualification: '/Application/RiskQualification',

  //OnSubmit Route Vital
  RaterModalSubmit: '/Application/Summary/RaterModal',
  PolicyHolderSubmit: '/Commercial/PayrollProtection/Application/PolicyHolder',
  RiskQualifiersSubmit: '/Application/RiskQualifiers',
  RiskConfirmQualificationSubmit: '/Application/RiskQualifiers-ConfirmQualificationSubmit',
  AgeQualificationDeclineSubmit: '/Application/PolicyHolder-DeclineQualificationSubmit',
  OnSubmitToUw: '/Application/Summary/ReferralToUw',
  OnSubmitToUwEnd: '/Application/Summary/ReferralToUwEndorsement',
  DashboardAccountHub: '/Dashboard/Accounthub',
  ApplicationSummary: '/Application/Summary',
  EndorsementSummary: '/Endorsement/Summary',
  EndorsementApproved: '/Application/Summary/EndorsementApproved',
  IssueEndorsement: '/Application/Summary-IssueEndorsement',
};

export const CoverageKeys = {
  PayrollProtection: 'payrollAndLeaseReimbursement',
  LeasedMedicalEquipment: 'equipmentLeaseReimbursement',
  MedicalPracticeLoan: 'medicalPracticeLoanReimbursement',
  LeasedMedicalEquipmentToggle: 'leasedMedicalEquipmentToggle',
  MedicalPracticeLoanToggle: 'medicalPracticeLoanToggle',
};

export const PremiumKeys = {
  MedicalPracticeLoanPremium: 'MedicalPracticeLoanPremium',
};

export const commonKeys = {
  Code: 'Code',
  Description: 'Description',
  Value: 'Value',
  Text: 'Text',
  ActionEmailQuote: 'EmailQuote',
  ActionEmailFormalQuote: 'EmailFormalQuote',
  IsErrored: 'IsErrored',
  Valid: 'Valid',
  Errors: 'Errors',
  EmptyString: '',
  DefaultTemplate: 'Default Template',
  ModuleQuote: 'Quote',
  ModuleApplication: 'Application',
  ModuleEndorsement: 'Endorsement',
  ModuleRenewal: 'Renewal',
  ModuleCancel: 'Cancel',
  ModuleReinstate: 'Reinstate',
  RoleAgent: 'Agent',
  RoleAgents: 'Agents',
  Agency: 'Agency',
  Agencies: 'Agencies',
  RoleOutsideMGA: 'OutSideMGA',
  RoleUW: 'UW',
  RoleSUW: 'SUW',
  RoleUnderwriter: 'Underwriter',
  ActionAllow: 'Allow',
  ActionRefer: 'Refer',
  ActionBlock: 'Block',
  ActionInEligible: 'InEligible',
  ActionEmailAgent: 'agentEmail',
  ActionEmailUnderWriter: 'underwriterEmail',
  ActionPrintQuote: 'PrintQuote',
  ActionDownloadRatesheet: 'DownloadRatesheet',
  ActionSmsQuote: 'SmsQuote',
  ActionEmailAndDownload: 'ActionEmailAndDownload',
  NotificationTypeSMS: 'S',
  NotificationTypeEmail: 'E',
  NotificationFormatHTML: 'html',
  NotificationFormatPDF: 'pdf',
  NotificationFormatTEXT: 'text',
  TemplateNameNotificationAgent: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/${process.env.NEXT_PUBLIC_LINE_OF_BUSINESS}/common/Notifications/templateForAgent.html`,
  TemplateNameNotificationBind: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/${process.env.NEXT_PUBLIC_LINE_OF_BUSINESS}/common/Notifications/bindsuccessmailbody.html`,
  TemplateNameNotificationUnderWriter: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/${process.env.NEXT_PUBLIC_LINE_OF_BUSINESS}/common/Notifications/templateForUnderWriter.html`,
  TemplateNameNotificationFormalQuote: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/${process.env.NEXT_PUBLIC_LINE_OF_BUSINESS}/common/Notifications/formalquote.html`,
  TemplateNameNotificationFormalQuoteMessageBody: `${process.env.NEXT_PUBLIC_CLIENT}/commercial/auto/common/formalquotemessagebody.html`,
  TemplateNameCancelReinstate: `${process.env.NEXT_PUBLIC_CLIENT}/commercial/auto/common/REI_CAN_document.html`,
  TemplateORRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/PP/common/RateSheets/TX.html`,
  TemplateRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/PP/common/RateSheets/TX.html`,
  TemplateNameInsuredPaymentConfirmation: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/HO3/common/Notifications/agentpaymentconfirmation.html`,
  TemplateNamePaymentRequest: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/HO3/common/Notifications/agentpaymentconfirmation.html`,
  TemplateNameAgentPaymentConfirmation: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/HO3/common/Notifications/agentpaymentconfirmation.html`,
  TrueString: 'true',
  FalseString: 'false',
  PageChangeFormName: 'pageChangeForm',
  New: 'new',
  SubmitAndAddAnother: 'submitAndAddAnother',
  SubmitOnly: 'SubmitOnly',
  CloseModal: 'closeModal',
  Completed: 'completed',
  Errored: 'errored',
  Deleted: 'Deleted',
  DatatTableMode: 'checkbox',
  AddNewDriver: 'addnewDriver',
  Disabled: 'disabled',
  Disable: 'disable',
  Selected: 'selected',
  Options: 'options',
  FMCSA: 'FMCSA',
  YesString: 'Yes',
  NoString: 'No',
  TemplateNameDeclineSubmission: `${process.env.NEXT_PUBLIC_CLIENT}/templates/commercial/auto/common/notifications/submissiondecline.html`,
  TemplateNameHoldSubmission: `${process.env.NEXT_PUBLIC_CLIENT}/templates/commercial/auto/common/notifications/submissionhold.html`,
  TemplateNameHazardHubDocument: `diep2/${process.env.NEXT_PUBLIC_CLIENT}/templates/Personal/${process.env.NEXT_PUBLIC_LINE_OF_BUSINESS}/common/ThirdParty/templateForHazardHub.html`,
  ThirdPartyDocument: 'Third Party Document',
  Communications: 'Communications',
  Email: 'Email',
  PhoneNumber: 'Phone Number',
  UnderWriter: 'UnderWriter',
  Reason: 'Reason',

  Added: 'Added',
  LocationTypeArray: 'array',
  ExtraSubmitBTN: 'extraSubmitBTN',
  RoleUnderwritingManager: 'Underwriting Manager',
  Individual: 'Individual',
  RoleMGA: 'MGA',

  TemplateGLRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/CA/common/RateSheets/GL.html`,
  TemplateALRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/CA/common/RateSheets/AL.html`,
  TemplateMTGRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/CA/common/RateSheets/CG.html`,
  TemplatePDRateSheet: `${process.env.NEXT_PUBLIC_CLIENT}/templates/Commercial/CA/common/RateSheets/PD.html`,

  // ih
  Key: 'Key',
  Label: 'Label',
  ViolationGroup: 'ViolationGroup',
  ViolationType: 'ViolationType',
  DaysLapsed: 'DaysLapsed',
  SixMonthsPriorCoverage: 'SixMonthsPriorCoverage',
  NSDMotorClub: 'NSDMotorClub',
  ResidenceType: 'ResidenceType',
  PhysicalConditionStatement: 'PhysicalConditionStatement',
  NewBusiness: 'NewBusiness',
  ADDTravelClub: 'ADDTravelClub',
  // WetSignatureTemplate: "ih/personal/auto/ga/canc_req.html",
  Zip: 'Zip',
  Duplicate: 'Duplicate',
  NonRenewalReason: 'NonRenewalReason',
  NonRenewalType: 'NonRenewalType',
  Id: 'Id',
  QuoteCover: 'QTC1',
  ActionEmailQuoteIndication: 'EmailQuoteIndication',
  Underwriter: 'Underwriter',
};
